/* eslint-disable no-undef */
const downloadFiles = (file, fileName) => {
  const a = document.createElement('a');
  const url = window.URL.createObjectURL(file);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};
export default downloadFiles;
